
import glovesIcon from "../../assets/images/icons/gloves.svg";
import worldIcon from "../../assets/images/icons/world.svg";
import deliveryIcon from "../../assets/images/icons/delivery.svg";
import warehouseIcon from "../../assets/images/icons/warehouse.svg";

const iconBoxesData = [
  {
    icon: glovesIcon,
    imageAlt: "gloves",
    title: "idealnie dopasowane produkty",
  }, {
    icon: deliveryIcon,
    imageAlt: "delivery",
    title: "szybka realizacja zamówień",
  }, {
    icon: worldIcon,
    imageAlt: "world",
    title: "międzynarodowa współpraca",
  }, {
    icon: warehouseIcon,
    imageAlt: "warehouse",
    title: "nowoczesny magazyn i centrum logistyczne",
  },
];

export { iconBoxesData };